import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  findFreeBusy (locationId, startDate, endDate, duration, peopleSelected, equipmentSelected) {
    const equipmentIds = equipmentSelected.length > 0 ? '&equipmentId=' + equipmentSelected.join('&equipmentId=') : ''
    return Axios.get(`api/public/clients/${this.getClientId()}/locations/${locationId}/freeBusy/startDate/${startDate}/endDate/${endDate}?minutesToRoundUp=${duration}&numberOfParticipants=${peopleSelected}${equipmentIds}`)
  },
  findFreeBusyRooms(eventId, startDate, endDate, roomIds) {
    const roomIdsParameter = roomIds.length > 0 ? roomIds.join(',') : ''
    return Axios.get(`api/public/clients/${this.getClientId()}/rooms/freeBusy?startDate=${startDate}&endDate=${endDate}&eventId=${eventId}&roomIds=${roomIdsParameter}`)
  },
  getEvents (cancelToken, offset, limit, locationSelected, startDate, endDate, peopleSelected, equipmentSelected) {
    const equipmentIds = equipmentSelected.length > 0 ? '&equipmentId=' + equipmentSelected.join('&equipmentId=') : ''
    const locationIds = locationSelected.length > 0 ? '&locationId=' + locationSelected.join('&locationId=') : ''
    // return Axios.get('http://localhost:3000/freeBusy')
    return Axios.get(`api/public/clients/${this.getClientId()}/events?&offset=${offset}&limit=${limit}${locationIds}&startDate=${startDate}&endDate=${endDate}&numberOfParticipants=${peopleSelected}${equipmentIds}`, {
      cancelToken: cancelToken
    })
  },
  getEventsAttendees (cancelToken, startDate, endDate, attendee) {
    // return Axios.get('http://localhost:3000/getEventsAttendees')
    return Axios.get(`api/public/clients/${this.getClientId()}/users/${attendee}/freebusy?startDate=${startDate}&endDate=${endDate}`, {
      cancelToken: cancelToken
    })
  },
  save (event) {
    if (event.id) {
      const id = event.id
      delete event.id
      return Axios.put(`api/public/clients/${this.getClientId()}/events/${id}`, event)
    } else {
      return Axios.post(`api/public/clients/${this.getClientId()}/events`, event)
    }
  },
  cancel (userEmail, eventId) {
    return Axios.delete(`api/public/clients/${this.getClientId()}/users/${userEmail}/events/${eventId}`)
  },
  findBooks (userEmail, startDate, endDate) {
    return Axios.get(`api/public/clients/${this.getClientId()}/users/${encodeURIComponent(userEmail)}/events/startDate/${startDate.clone().utc().format()}/endDate/${endDate.clone().utc().format()}`)
  },
  findBooksByLocation (locationId) {
    return Axios.get(`api/public/clients/${this.getClientId()}/locations/${locationId}/events/upcoming`)
  },
  cancelRoomEvent (cancelParameters) {
    return Axios.request({
      url: `api/public/clients/${this.getClientId()}/rooms/${cancelParameters.roomId}/events/${cancelParameters.eventId}/cancel`,
      method: 'delete',
      data: {
        reason: cancelParameters.reason,
        cancelAllCombinations: cancelParameters.cancelAllCombinations
      }
    })
  },
  getBookingEvent(eventId){
    return Axios.get(`api/public/clients/${this.getClientId()}/events/${eventId}`)
  },
  getSiteData(client){
    return Axios.get(`api/external/clients/${client}`)
  }
}
